<template>
  <div id="ticketDetails">

    <div class="section-content" ref="scrollArea">
      <template v-if="selected">
        <!-- USER DETAILS -->
        <div class="vo-card">
        
          <div class="vo-header">
            User Details
            <!-- <div class="vo-actions"></div> -->
          </div>
          <div class="vo-content">
            <div class="avatar">
              <vo-avatar :user="selected" :size="44"></vo-avatar>
            </div>
            <div class="details">

              <div class="vo-s-list">
                <div class="name">Name</div>
                <div class="value">{{ selected.fullName }}</div>
              </div>
              
              <div class="vo-s-list">
                <div class="name">Joined Date</div>
                <div class="value">{{ selected.joined | dateShorthand }}</div>
              </div>

              <div class="vo-s-list">
                <div class="name">Email Address</div>
                <div class="value">{{ selected.email }}</div>
              </div>


              <div class="vo-s-list">
                <div class="name">Phone Number</div>
                <div class="value">{{ selected.phone }}</div>
              </div>

            </div>
            <div class="clear"></div>
          </div>
        </div>
        
        <!-- ROLES -->
        <div class="vo-card">
        
          <div class="vo-header">
            Roles
            <div class="vo-actions">
              <v-btn small fab flat class="icon-button" @click="routeAddQuery('dialog', 'role-manage')" v-if="hasPermissions(['role'])">
                <v-icon medium>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="role" v-for="(role, i) in selected.roles" :key="i">
            <div class="left">
              
              <div class="title-value">{{ $store.getters.role(role).title }}</div>
              
              <div class="role-details" :class="{has: $store.getters.role(role).property, selectable: $store.getters.role(role).property && hasPermissions(['property'])}">
                <span @click="openProperty($store.getters.role(role))">{{ $store.getters.role(role).property ? $store.getters.property($store.getters.role(role).property).name : 'All Properties'}}</span>
              </div>
              
              <div class="role-details" :class="{has: $store.getters.role(role).unit, selectable: $store.getters.role(role).unit && hasPermissionsInProperty(['unit'], $store.getters.role(role).property)}">
                <span @click="openUnit($store.getters.role(role))">{{ $store.getters.role(role).unit ? $store.getters.unit($store.getters.role(role).unit).title : 'All Units' }}</span>
              </div>
            
            </div>
            <div class="right" v-if="hasPermissions(['role'])">
              <v-btn small fab flat class="vo-icon-button" @click="routeAddQueries({ dialog: 'role-manage', dialogAction: 'edit', dialogItem: role })">
                <v-icon medium>mdi-pencil</v-icon>
              </v-btn>
              <v-btn small fab flat class="vo-icon-button delete" @click="removeRoleDialog(role)">
                <v-icon medium>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
          <vo-list-footer :list="{items: selected.roles, name: 'Roles'}"></vo-list-footer>
        </div>

      </template>

      <template v-else>
        <vo-empty-state text="SELECT A PERSON"></vo-empty-state>
      </template>
    </div>
    
    <vo-details-header></vo-details-header>
  
  </div>
</template>

<script>

  import DetailsMixin     from '../mixins/detailsMixin.js';
  import permissionMixin  from '../mixins/permissionMixin.js';

  export default {
    mixins: [DetailsMixin, permissionMixin],
    data () {
      return {
        
      }
    },
    methods: {

      removeRoleDialog (role) {
        
        var rolePopulated = this.$store.getters.role(role);
        
        // Init remove params
        var params = {
          user: this.selected,
          company: this.$store.getters.company._id,
          role: {
            _id: role
          }
        };

        // Deleting someone's role that's not their last role
        if (this.selected.roles.length > 1) {

          Dialog.showDialog({
            title: 'Remove Role',
            html: 'Are you sure you want to remove the role <b>' + rolePopulated.title + '</b> from ' + this.selected.fullName + '?',
            confirm: {
              title: 'Remove',
              action: () => {
                
                return this.$store.dispatch('removeUserRole', params)
                .then(data => {
                  Toast.show('Role removed.', 'success');
                  return Promise.resolve();
                })
                .catch(e => {
                  console.log(e);
                  Toast.showError(e);
                  return Promise.reject();
                })
              
              }
            }
          });
        }

        // Deleting someone's last role
        else {

          Dialog.showDialog({
            title: 'Remove User',
            html: 'Removing this role will remove ' + this.selected.fullName + ' from your company. Are you sure you want to remove the role <b>' + rolePopulated.title + '</b> from ' + this.selected.fullName + '?',
            confirm: {
              title: 'Remove',
              action: () => {
                
                return this.$store.dispatch('removeUserRole', params)
                .then(data => {
                  this.page.list.removeItem(this.selected._id);

                  this.routeRemoveQuery('details');
                  this.page.selected = false;

                  Toast.show('User removed.', 'success');
                  return Promise.resolve();
                })
                .catch(e => {
                  console.log(e);
                  Toast.showError(e);
                  return Promise.reject();
                })
              
              }
            }
          });

        }

      },

      loadUser () {
        this.selectFromDetails(this.page, 'loadUser', {
          company: this.$store.getters.company._id,
          user: this.$route.query.details
        });
      },

      openProperty (role) {
        if (!(role.property && this.hasPermissions(['property']))) return;

        this.$router.push({
          name: 'properties',
          query: {
            details: role.property
          }
        });
      },

      openUnit (role) {
        if (!(role.unit && this.hasPermissionsInProperty(['unit'], role.property))) return;

        this.$router.push({
          name: 'units',
          query: {
            details: role.unit
          }
        });
      }

    },

    computed: {

      selected () {
        return this.$store.getters.user(this.page.selected);
      }

    },
    
    watch: {

      '$route.query.details' () {
        this.loadUser();
      },

      selected () {
         this.$refs.scrollArea.scrollTop = 0;
      }

    },

    created () {
      this.loadUser();
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketDetails {

    @include fontPrimary400();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
      
    .section-content {
      @include scrollContainer();
      top: 48px;

      background: $lightGreen; 
      padding: 16px;
      box-sizing: border-box;
    }

    .vo-card {

      .avatar {
        margin: 0 20px 0 0;
        float: left;
      }

      .details {
        float: left;
      }

      .role {
        
        position: relative;
        height: 90px;
        
        .left {
          @include fontPrimary400;
          
          position: absolute;
          left: 16px;
          top: 8px;
          right: 100px;


          .title-value {
            @include fontPrimary500;
            @include textEllipsis;
            margin: 8px 0 0;
            color: $black87;
            user-select: none;
            pointer-events: none;
          }

          .role-details {
            @include textEllipsis;
            color: $black24;
            user-select: none;
            pointer-events: none;

            &.has {
              color: $black54;
            }

            &.selectable span {
              color: $primary;
              cursor: pointer;
              pointer-events: auto;
            }
          }

          .access-level {
            @include textEllipsis;
            margin: 2px 0 0 0;
            color: $black54;
            font-size: 12px;
          }
        }

        .right {
          position: absolute;
          right: 8px;

          .vo-icon-button {
          
            float: left;
            margin: 23px 0 0 4px;

            &.delete {
  
              i {
                color: $delete_red;
              }
            }

          }
        }

        &:not(last-of-type) {
          border-bottom: $borderBlack12;
        }

      }

    } // .details-card
  }

</style>



// WEBPACK FOOTER //
// src/components/PeopleDetails.vue